import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import TextInput from '../../components/formComponents/inputs/TextInput';
import RichTextDisplay from '../../components/RichTextDisplay';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';

class ShortEssaySlide extends Component {
    static propTypes = {
        essay: PropTypes.shape({
            description: PropTypes.string,
            characterLimit: PropTypes.number,
            hideCharacterCount: PropTypes.bool
        }),
        completedData: PropTypes.shape({
            data: PropTypes.object,
            isCompleted: PropTypes.bool
        }),
        canMoveToNext: PropTypes.func,
        onChange: PropTypes.func,
        nextSectionName: PropTypes.string,
        isRequired: PropTypes.bool,
        currentUser: PropTypes.object,
        name: PropTypes.string,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        hideBookmark: PropTypes.bool,
        sendWorkspaceSegementEvent: PropTypes.func,
        isRefSheet: PropTypes.bool,
    };

    componentDidMount() {
        const { onChange, canMoveToNext, completedData = {}, isRequired = false } = this.props;
        canMoveToNext((!isEmpty(completedData) && completedData.isCompleted) || !isRequired); // TODO: fix this back if we remove un-completed items from completedItems

        if (!isRequired && isEmpty(completedData)) {
            const isCompleted = true;
            const isAnswered = false;
            onChange(null, isCompleted, isAnswered);
        }
    }

    _changeHandler = (event) => {
        const { onChange, canMoveToNext, isRequired } = this.props;
        const { value } = event.target;
        const isAnswered = !!value;
        const isCompleted = !!value || value === '';
        const data = {
            answer: value
        };

        if (onChange) {
            onChange(data, isCompleted, isAnswered);
        }
        if (canMoveToNext) {
            canMoveToNext(!isRequired || isAnswered);
        }
    };

    render() {
        const {
            currentUser,
            name,
            nextSectionName,
            essay: { description = '', characterLimit = 800, hideCharacterCount },
            sectionId,
            sectionItemId,
            completedData,
            hideBookmark,
            sendWorkspaceSegementEvent,
            isRefSheet = false,
        } = this.props;
        const rows = Math.ceil(characterLimit / 100) || 3;
        const val = get(completedData, 'data.answer', '') || '';
        const characterCount = characterLimit - (val.length || 0);
        const countClass = characterCount < 15 ? ' countHigh' : '';
        return (
            <div className={'shortEssaySlide'}>
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div className={'playerContent'}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                    <TextInput
                        componentClass={'textarea'}
                        rows={rows}
                        type={'text'}
                        value={val}
                        placeholder={''}
                        onChange={this._changeHandler}
                        maxLength={`${characterLimit}`}
                    />
                    {!hideCharacterCount ? (
                        <span className={`characterCounter${countClass}`}>{characterCount}</span>
                    ) : null}
                </div>
            </div>
        );
    }
}

export const ShortEssaySlideComponent = ShortEssaySlide;
export default TrackPlayerSlideComponent(ShortEssaySlide);
